Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchPreviewPage = void 0;
const getters_1 = require("./getters");
const admin_core_1 = require("@wheelroom/admin-core");
const react_1 = require("react");
const defaultNeedsFetch = (pageProps, previewPage) => {
    if (!previewPage) {
        return true;
    }
    return pageProps.data.page.path !== previewPage.path;
};
exports.useFetchPreviewPage = (setPreviewPage, needsFetch = defaultNeedsFetch) => {
    const { adminCoreState } = react_1.useContext(admin_core_1.AdminCoreContext);
    const pagePreviewStore = getters_1.getPreviewPageStore(adminCoreState);
    react_1.useLayoutEffect(() => {
        const pageProps = adminCoreState.pageProps;
        if (!pagePreviewStore || !pageProps) {
            return;
        }
        const pagePreviewState = pagePreviewStore.state;
        if (!pagePreviewState.inPreviewMode) {
            return;
        }
        const previewPage = pagePreviewState.previewPage;
        if (!pagePreviewState.isFetching && needsFetch(pageProps, previewPage)) {
            pagePreviewStore.actions.fetchPage(adminCoreState);
        }
        setPreviewPage(previewPage);
    }, [adminCoreState]);
};
//# sourceMappingURL=use-fetch-preview-page.js.map